import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tab-routing-addresses__title" }

import { computed, inject, onMounted, ref } from 'vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';
import RoutingAddressesLoading from 'vcomponents/overview/tabs/routingAddresses/RoutingAddressesLoading.vue';
import RoutingAddressesEmptySiren from 'vcomponents/overview/tabs/routingAddresses/RoutingAddressesEmptySiren.vue';
import RoutingAddressesEmptyNotDetected from 'vcomponents/overview/tabs/routingAddresses/RoutingAddressesEmptyNotDetected.vue';
import RoutingAddressesList from 'vcomponents/overview/tabs/routingAddresses/RoutingAddressesList.vue';
import { fetchRoutingAddresses, MOCK_DISPLAY_OVERRIDE } from 'api/routingAddressesService';
import type { Translator } from 'types/injects/translator.type';
import type { RoutingAddress } from 'types/entities/einvoicing/routingAddress.type';

type DisplayState = 'siren-missing' | 'not-detected' | 'has-addresses';


export default /*@__PURE__*/_defineComponent({
  __name: 'TabRoutingAddresses',
  setup(__props) {

const $t = inject('$t') as Translator;
const translations: Record<string, string> = {
    title: $t.__('overview.tabs.TabRoutingAddresses.title'),
    facturationElectroniquePill: $t.__(
        'overview.tabs.TabRoutingAddresses.facturation_electronique_pill',
    ),
};

const loading = ref<boolean>(true);
const routingAddresses = ref<RoutingAddress[]>([]);

const displayState = computed<DisplayState>(() => {
    if (MOCK_DISPLAY_OVERRIDE === 'siren-missing') {
        return 'siren-missing';
    }
    if (MOCK_DISPLAY_OVERRIDE === 'not-detected') {
        return 'not-detected';
    }
    // TODO (SAAS-32515) : 'auto': mocked data drives the rendering. When the backend lands and the override is
    // removed, re-introduce the real SIREN check here (read `siren` from the overview store
    // via `useStore().getters.dataFetch.informations`) and return 'siren-missing' when absent.
    return routingAddresses.value.length === 0 ? 'not-detected' : 'has-addresses';
});

const fetch = async (): Promise<void> => {
    try {
        loading.value = true;
        routingAddresses.value = await fetchRoutingAddresses();
    } finally {
        loading.value = false;
    }
};

const setDefault = (id: number): void => {
    // Local-only mock: exactly one address is `isDefault`. Activating one deactivates the others.
    // TODO(SAAS-32324): replace with a real API call when the backend lands.
    routingAddresses.value = routingAddresses.value.map((address) => ({
        ...address,
        isDefault: address.id === id,
    }));
};

onMounted(() => {
    fetch();
});

return (_ctx: any,_cache: any) => {
  const _component_CompassPill = _resolveComponent("CompassPill")!

  return (_openBlock(), _createBlock(TabLayout, null, {
    title: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createTextVNode(_toDisplayString(translations.title) + " ", 1 /* TEXT */),
        _createVNode(_component_CompassPill, {
          label: translations.facturationElectroniquePill,
          color: _ctx.CompassEnums.PillColor.ORANGE,
          variant: _ctx.CompassEnums.PillVariant.PASTEL,
          size: _ctx.CompassEnums.PillSize.EXTRA_SMALL
        }, null, 8 /* PROPS */, ["label", "color", "variant", "size"])
      ])
    ]),
    content: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createBlock(RoutingAddressesLoading, { key: 0 }))
        : (displayState.value === 'siren-missing')
          ? (_openBlock(), _createBlock(RoutingAddressesEmptySiren, { key: 1 }))
          : (displayState.value === 'not-detected')
            ? (_openBlock(), _createBlock(RoutingAddressesEmptyNotDetected, { key: 2 }))
            : (_openBlock(), _createBlock(RoutingAddressesList, {
                key: 3,
                addresses: routingAddresses.value,
                onSetDefault: setDefault
              }, null, 8 /* PROPS */, ["addresses"]))
    ]),
    _: 1 /* STABLE */
  }))
}
}

})